module.exports = __webpack_public_path__ + "static/media/close-page-detail.52dc29b2.svg";